// Technical integration only: approved paid-media attribution keys are forwarded; preview/theme or arbitrary query state is never copied.
(function(){
  var qs = window.location.search;
  if (!qs) return;
  document.querySelectorAll('.product-link').forEach(function(a){
    try {
      var u = new URL(a.href, window.location.origin);
      var incoming = new URLSearchParams(qs);
      var allowed = new Set(['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid','ttclid','msclkid','mc_cid','mc_eid','campaign_id','adset_id','ad_id','creative_id']);
      incoming.forEach(function(v,k){ if (allowed.has(k) && !u.searchParams.has(k)) u.searchParams.set(k,v); });
      a.href = u.toString();
    } catch (e) {}
  });
})();

// Surface the sticky CTA after the product section and keep it out of the tab order before then.
(function(){
  var productSection = document.getElementById('the-kit');
  var sticky = document.getElementById('sticky-offer');
  if (!productSection || !sticky) return;
  var revealed = false;
  function reveal() {
    if (!revealed) return;
    sticky.classList.add('is-visible');
    sticky.setAttribute('aria-hidden','false');
    sticky.removeAttribute('inert');
  }
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if (entry.isIntersecting) revealed = true; });
      reveal();
    }, {threshold:.15});
    obs.observe(productSection);
  }
  // Fallback for browsers that defer observer delivery during an immediate anchor scroll.
  function checkProductPosition() {
    if (productSection.getBoundingClientRect().top <= window.innerHeight * .85) { revealed = true; reveal(); }
  }
  window.addEventListener('scroll', checkProductPosition, {passive:true});
  window.addEventListener('resize', checkProductPosition);
  checkProductPosition();
})();

// Keep FAQ tidy: one open item at a time.
document.querySelectorAll('#faq details').forEach(function(item){
  item.addEventListener('toggle', function(){
    if (item.open) document.querySelectorAll('#faq details').forEach(function(other){ if (other !== item) other.open = false; });
  });
});
